import PublicationsShow from "../components/publications/Show";

export default [
  { name: 'Publications', path: '/publications', component: PublicationsShow,  }
]
